"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _KYC_IMLegacyFormContainer = _interopRequireDefault(require("./KYC_IMLegacyFormContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _KYC_IMLegacyFormContainer["default"];